export default "__VITE_ASSET__f321482a__"